import { render, staticRenderFns } from "./Inside.vue?vue&type=template&id=1252b558&"
import script from "./Inside.vue?vue&type=script&lang=js&"
export * from "./Inside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports